import script from "./SupplierView.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierView.vue?vue&type=script&setup=true&lang=js"

import "./SupplierView.vue?vue&type=style&index=0&id=2f145ea3&lang=css"

const __exports__ = script;

export default __exports__